import React from 'react';
import { Navigate } from 'react-router-dom';
import { useRole } from '@/contexts/RoleContext';
import { GlobalLoading } from '@/components/ui/global-loading';

interface AdminRouteProps {
  children: React.ReactNode;
}

export const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { isAdmin, isLoading } = useRole();

  if (isLoading) {
    return <GlobalLoading isLoading={true} />;
  }

  if (!isAdmin) {
    return <Navigate to="/acesso-negado" replace />;
  }

  return <>{children}</>;
};